import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from "gatsby";
import WistiaVideo from '../../components/wistiaVideo/wistiaVideo';
import  {video, video__wrapper} from './video.module.scss';
/**
 * CMS Component: DatoCmsModuleTextContent
 * 
 */
const Video = ({className, data, loop, ...other}) => {
    const {externalVideo, wistiaId, videoType} = data || {};
    let url = null;
    switch(externalVideo?.provider){
      case 'youtube': 
          url = `https://www.youtube.com/embed/${externalVideo.providerUid}`;
          if(loop){
            url += `?playlist=${externalVideo.providerUid}&loop=1&autoplay=1&controls=0&mute=1`;
          }
          break;
        case 'vimeo':
          url = `https://player.vimeo.com/video/${externalVideo.providerUid}`;
          break;
        case 'facebook':
          url = `https://www.facebook.com/video/embed?video_id=${externalVideo.providerUid}`;
          break;
        default:
      };
   
    
    return (
      <div className={`${video} video ${className || ''}`} {...other}>
        <div className={`${video__wrapper}`}>
        {
          (wistiaId && !externalVideo) &&
          <WistiaVideo id={wistiaId} controls={true} videoType={videoType} />
        }
        {
          url && 
          <iframe src={url} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          frameBorder="0"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
          title={externalVideo.title}
          data-width="auto"
          /> 
        }
        </div>
      </div>
    );
};

Video.propTypes = {
  /**
  * Data from cms
  */
  data: PropTypes.shape({
    anchor: PropTypes.string,
    backgroundColor: PropTypes.string,
    border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),
    content: PropTypes.array,
    contentType: PropTypes.string,
    copySize: PropTypes.string,
    images : PropTypes.array,
    narrowContent: PropTypes.string
  }),
  className: PropTypes.string,
};

export default Video;

export const VideoFragment = graphql`
fragment VideoFragment on DatoCmsComponentVideo {
   
  id: originalId
  externalVideo{
    provider
    providerUid
    title
  }
  wistiaId
  videoType
}
`;